import { getBackendUrl } from '../../lib/backendUrl';
import { fetchWithRetry } from '../../lib/fetchWithRetry';
import storage from '../../lib/storage';

async function getDeviceHeaders() {
  const deviceIdKey = 'kakeibo_device_id';
  let deviceId = await storage.getItem(deviceIdKey);
  if (!deviceId) {
    deviceId = `inst-${Date.now()}-${Math.random().toString(36).slice(2,9)}`;
    try { await storage.setItem(deviceIdKey, deviceId); } catch (_) {}
  }
  const platform = (typeof navigator !== 'undefined' && (navigator.product || 'web')) as string;
  return {
    'X-Device-Id': deviceId,
    'X-App-Id': 'kakeibo',
    'X-Platform': platform,
  } as Record<string,string>;
}

async function buildHeaders() {
  const headers: Record<string,string> = { 'Content-Type': 'application/json', ...(await getDeviceHeaders()) };
  const token = await storage.loadAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return { headers, token } as any;
}

export async function getProfile() {
  const backend = getBackendUrl();
  const { headers, token } = await buildHeaders();
  const opts: any = { headers };
  if (!token) opts.credentials = 'include';
  const res = await fetchWithRetry(`${backend}/users/me`, opts, { retries: 2 });
  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(txt || `Failed to fetch profile (${res.status})`);
  }
  const body = await res.json().catch(() => null);
  return body;
}

export async function updateProfile(payload: any) {
  const backend = getBackendUrl();
  const { headers, token } = await buildHeaders();
  const opts: any = { method: 'POST', headers, body: JSON.stringify(payload) };
  if (!token) opts.credentials = 'include';
  const res = await fetchWithRetry(`${backend}/users/me/profile`, opts, { retries: 2 });
  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(txt || `Failed to update profile (${res.status})`);
  }
  const body = await res.json().catch(() => null);
  return body;
}

export async function deleteAccount() {
  const backend = getBackendUrl();
  const { headers, token } = await buildHeaders();
  const baseOpts: any = { headers };
  if (!token) baseOpts.credentials = 'include';

  const deleteRes = await fetchWithRetry(`${backend}/users/me`, { ...baseOpts, method: 'DELETE' }, { retries: 1 });
  if (deleteRes.ok) {
    return deleteRes.json().catch(() => ({ ok: true }));
  }

  if (deleteRes.status !== 404 && deleteRes.status !== 405) {
    const txt = await deleteRes.text().catch(() => '');
    throw new Error(txt || `Failed to delete account (${deleteRes.status})`);
  }

  const fallbackRes = await fetchWithRetry(`${backend}/users/me/delete`, { ...baseOpts, method: 'POST' }, { retries: 1 });
  if (!fallbackRes.ok) {
    const txt = await fallbackRes.text().catch(() => '');
    throw new Error(txt || `Failed to delete account (${fallbackRes.status})`);
  }

  return fallbackRes.json().catch(() => ({ ok: true }));
}

export default {
  getProfile,
  updateProfile,
  deleteAccount,
};
